<div class="patient-dropdown" (click)="onOpenDropdown()" [ngClass]="{'focus': dropdownIsVisible, 'disabled': formControl && formControl.disabled}">
  <label *ngIf="selectedOption">{{ displayValue }}</label>
  <label class="placeholder" *ngIf="!selectedOption">{{ placeholder }}</label>

  <a class="arrow"><i class="far fa-angle-down" aria-hidden="true"></i></a>
  <a class="clear-selection" (click)="onClearSelection(true)" *ngIf="selectedOption"><i class="far fa-times" aria-hidden="true"></i></a>

  <div class="autocomplete-dropdown" *ngIf="dropdownIsVisible">
    <div class="autocomplete-search">
      <div [formGroup]="filterForm" class="form-group">
        <input #searchTermInput formControlName="searchTerm" type="text" (click)="$event.stopPropagation();">
      </div>

      <i class="far fa-search" aria-hidden="true"></i>
    </div>

    <p *ngIf="searchHasValue && filteredPatients.length === 0">No patients found!</p>

    <div *ngIf="filteredPatients.length > 0 && isLoading === false" class="patient-results">
      <ul>
        <li *ngFor="let option of filteredPatients" [id]="option.value">
          <a (click)="onSelectPatient(option)">
            <span>{{ option.text }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
